import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HgCommonRoutingModule } from './hg-common-routing.module';
import { ContactusComponent } from './contactus/contactus.component';
import { HelpComponent } from './help/help.component';
import { FormsModule } from '@angular/forms';
import { NgxUploaderModule } from 'ngx-uploader';
// import { FileSelectDirective } from 'ng2-file-upload';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { PreContactComponent } from './pre-contact/pre-contact.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    HgCommonRoutingModule,
    FormsModule,
    NgxUploaderModule,
    FileUploadModule,
    NgxSpinnerModule
  ],
  exports : [
    HelpComponent,
    ContactusComponent,
    PreContactComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent
  ],
  declarations: [ContactusComponent, HelpComponent, PreContactComponent,
     HeaderComponent, FooterComponent, PrivacyPolicyComponent, TermsOfServiceComponent]
})
export class HgCommonModule { }
